import domReady from '@roots/sage/client/dom-ready';
import $, { data } from 'jquery';

import Swiper from 'swiper';
import { Controller, Navigation, Pagination, EffectFade, Autoplay, FreeMode, Thumbs } from 'swiper/modules';
Swiper.use([Controller, EffectFade, Navigation, Pagination, Autoplay, FreeMode, Thumbs]);

import { gsap, Power2 } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';

import 'bootstrap';

import Cookies from 'js-cookie';
import select2 from 'select2'

import JustValidate from 'just-validate';


/**
 * Application entrypoint
 */
domReady(async () => {

  gsap.registerPlugin(ScrollTrigger);


  let revealImage = document.querySelectorAll(".reveal-image");

  let imageReveal = revealImage.forEach((element) => {

    let img = $(element).find('img');
    let overlay = $(element).find('.overlay');
    let title = $(element).find('.image-title');


    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top center+=200px',
        once: true,
        toggleActions: "play none none none"
      }
    });

    tl.to(overlay, { duration: 1, height: "100%", ease: "Power2.ease" })
      .set(overlay, { duration: 0, bottom: 0, top: "unset" })
      .to(overlay, { duration: 1, height: "0%", ease: "Power2.ease" })
      .to(img, { duration: 0.2, opacity: 1, delay: -1 })
      .to(img, {
        duration: 2,
        scale: 1,
        ease: "Power2.easeInOut",
        delay: -1.2
      })
      .to(title, { duration: 0.6, opacity: 1 });

  });

  $('.filter-categories').select2({
    allowClear: true,
    minimumResultsForSearch: Infinity,
    width: '100%',
    language: "lv",

  });

  $('.filter-categories').on('select2:select', function (e) {
    $('#offer-category_' + e.params.data.id).prop('checked', true);
    $('.filter-selector option:selected').prop('disabled', true);
    $('[name="paged"]').val(1);
    $('#offers_filter').trigger('submit');
    $('.filter-categories').val(null).trigger('change');
    // updateEvents();
  });

  $('.filter-checkbox').on('change', function () {
    $('option[value="' + $(this).attr('value') + '"]').prop('disabled', false);
    $('#offers_filter').trigger('submit');
  });


  $('#offers_filter').on('submit', function (e) {

    var viewportTop = $(window).scrollTop();

    e.preventDefault();

    var formData = new FormData(document.getElementById('offers_filter'));

    window.location.hash = new URLSearchParams(formData).toString();
    $(window).scrollTop(viewportTop)

    formData.append('action', 'get_offers');
    formData.append('nonce', window.nonce);

    // alert('booo');


    $.ajax({
      url: window.ajax_url,
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      allowTouchMove: false,
      cache: false,
      success: function (data) {

        $('.card-items').html(data);

        const currentIndex = document.querySelector('.cards-swiper .current');


        new Swiper(".cards-swiper", {
          spaceBetween: 30,
          effect: "fade",
          fadeEffect: { crossFade: true },
          autoHeight: true,
          navigation: {
            nextEl: ".cards-next",
            prevEl: ".cards-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + "</span>";
            }
          },
          on: {
            slideChangeTransitionStart: function () {


              var blockOffers = $('.block-offers-cards');


                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();
                var blockOffersTop = blockOffers.offset().top;
                
                if (blockOffersTop > viewportBottom || blockOffersTop < viewportTop) {
                    // .block-offers-cards is out of viewport
                    $('html, body').animate({
                        scrollTop: (blockOffersTop - 36)
                    }, 500);
                }


            },
            slideChange: function (e) {
              $(currentIndex).html(e.realIndex + 1);
            },
          },
          speed: 700,
        });

      },
    });



  });

  $('#offers_filter').trigger('submit');


  const carousels = document.querySelectorAll('.block-offers-carousel');

  carousels.forEach((elem) => {

    const images = elem.querySelector('.swiper-img-block-imgs');
    const content = elem.querySelector('.swiper-img-block-content');
    const prevBtn = elem.querySelector('.sw-prev');
    const nextBtn = elem.querySelector('.sw-next');

    new Swiper(images, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 2000,
      allowTouchMove: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    new Swiper(content, {
      slidesPerView: 1,
      loop: false,
      effect: 'fade',
      speed: 1000,
      allowTouchMove: false,
      fadeEffect: { crossFade: true },

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

  });

  $('.goto-offer').on('click', function () {
    const id = $(this).closest('.content-column').find('.swiper-slide-active').data('goto');
    window.location.hash = '';
    window.location.hash = id;
  });



  if (Cookies.get('offers_visible') == 'true') {
    $('body').addClass('offers-visible');
  }

  const contact_forms = document.querySelectorAll('.contact-us-form');

  contact_forms.forEach((c_form) => {


    const validate = new JustValidate(c_form);

    if (c_form.querySelector('#first_name')) {
      validate
        .addField('#first_name', [
          {
            rule: 'required',
            errorMessage: window.error_required,
          },
        ]);
    }

    if (c_form.querySelector('#email')) {
      validate.addField('#email', [
        {
          rule: 'required',
          errorMessage: window.error_required,
        },
        {
          rule: 'email',
          errorMessage: window.error_email,
        },
      ])
    }

    if (c_form.querySelector('#phone')) {
      validate.addField('#phone', [
        {
          rule: 'required',
          errorMessage: window.error_required,
        },
      ])
    }

    if (c_form.querySelector('.accept-terms')) {
      validate.addField('.accept-terms', [
        {
          rule: 'required',
          errorMessage: window.error_required,
        },
      ])
    }



    validate.onSuccess(function () {

      var formData = new FormData(c_form);
      formData.append('action', 'save_case');
      formData.append('nonce', nonce);

      $.ajax({
        type: 'POST',
        url: ajax_url,
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        success: function (data) {
          console.log(data);
        }
      });

      $(c_form).css('opacity', 0);
      $(c_form).closest('.modal-content').find('.thank-you').addClass('visible').fadeIn();
      setTimeout(function(){
        $('.form-modal').modal('hide');
      }, 5000);
      

    });

  });

  if(document.querySelector('.offer-form')) {
    const o_form = document.querySelector('.offer-form');
    const validate = new JustValidate(o_form);

    validate
    .addField('#owner_code', [
      {
        rule: 'required',
        errorMessage: window.error_required,
      },
      {
        rule: 'customRegexp',
        value: /\b\d{4}-\d{2}-\d{2,3}\b/,
        errorMessage: window.error_code,
      },
    ]).onSuccess(function () {

      $('body').addClass('offers-visible');
      $('#offer_form').modal('hide');
      Cookies.set('offers_visible', true);
      

    });

  }

$(document).on('click', '.show-offer span', function(){
  $(this).closest('.offer-card').addClass('keep-open');
});

});



/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
